module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MT-4c7d23fb020fc84c90a297938308491e.png";